import { Component } from '@angular/core';
import { NavController, MenuController, Platform } from 'ionic-angular';
import { Auth } from '../../providers/auth';
import { LoadingController } from 'ionic-angular';
import { RegisterPage } from '../register/register'; 
//import { LoginPage } from '../login/login'; 
import { ToastController } from 'ionic-angular';
//import { WorkInProgressPage } from '../workinprogress/workinprogress';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { DataExchanger } from '../../providers/data-exchanger';

@Component({
  selector: 'page-lostpassword',
  templateUrl: 'lostpassword.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})

export class LostPasswordPage {
  usernameoremail: string;
  errorMessage: string;
  loader:any;

  pageWorkInProgressLoaded:boolean=false;

  logoutOk:boolean;

  constructor(public functions: Functions, public platform: Platform, public toastCtrl: ToastController, public dataexchanger: DataExchanger, public rubedoSideMenu: MenuController,  public translate: TranslateService, public navCtrl: NavController, public auth: Auth, public loadingCtrl: LoadingController) {
    this.errorMessage = "";
    this.pageWorkInProgressLoaded=false;
    
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(false, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(false);
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(false);
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  goToLogin(){
    this.navCtrl.pop();
    //this.navCtrl.setRoot(LoginPage, {});
  }

  goToRegister(){
    this.navCtrl.push(RegisterPage, {});
  }

  requestNewPassword(){
    if(this.functions.deviceIsOnline()){
      this.presentLoading();

      //0342e5aab7e4b guid anonymous
      
      // First logout. If logout is ok, login again. This is to avoid problems if you're already
      // logged in with session expired or if your logged to kreyon or xtribe

      this.logoutOk=false;
      this.auth.logout().then((response)=>{
        var responseString:string;
        responseString=response.toString();
        if(responseString.indexOf('LogoutIsOk')!=-1){
          this.logoutOk=true;
        }else{
          if(responseString.indexOf('User is not logged in')!=-1){
            this.logoutOk=true;
          }   
        }

        if(this.logoutOk){
          this.auth.requestNewPassword(this.usernameoremail).then((response)=>{
            var responseString:string;
            responseString=response.toString();
            this.loader.dismiss();
            if(responseString.indexOf('RequestNewPasswordIsOk')!=-1){
              this.translate.get('lostpassword_confirm').subscribe(value => { 
                this.errorMessage = value;
                this.functions.showMessage(this.toastCtrl, this.errorMessage);
                this.goToLogin();
              });
            }else{
              this.translate.get('lostpassword_wrongid').subscribe(value => { 
                this.errorMessage = value;
                this.functions.showMessage(this.toastCtrl, this.errorMessage);
              });
            }
          });
        }else{
          this.functions.showMessage(this.toastCtrl, this.auth.errorMessage);
          this.loader.dismiss();
        }
      });

    }else{
      this.translate.get('noConnection').subscribe(value => { 
        this.errorMessage = value;
        this.functions.showMessage(this.toastCtrl, this.errorMessage);
      });
    }
  }

  presentLoading() {
    this.translate.get('loading').subscribe(value => { 
      this.loader = this.loadingCtrl.create({
        content: value
      });
      this.loader.present();
    });
  }


  handleResizeEvents(event: KeyboardEvent) {
    if(this.navCtrl.getActive().name=="LoginPage"){
      if((event.target['innerWidth']<800 || event.target['innerHeight']<600) && !this.pageWorkInProgressLoaded){
        this.pageWorkInProgressLoaded=true;
        this.goToWorkInProgressPage();
      }
    }
    this.functions.setScaleForBigScreen();
  }
  
  goToWorkInProgressPage(){
    //this.navCtrl.push(WorkInProgressPage, {});
  }
}



// WEBPACK FOOTER //
// ./src/pages/lostpassword/lostpassword.ts